import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { SEOHead } from "@/components/SEOHead";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        await axios.get(`${API}/auth/me`, { withCredentials: true });
        navigate("/admin", { replace: true });
      } catch {
        setChecking(false);
      }
    };
    check();
  }, [navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-navy-950 flex items-center justify-center">
        <p className="text-slate-400 text-sm tracking-widest uppercase">Memeriksa sesi...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-navy-950 flex items-center justify-center px-6">
      <SEOHead title="Masuk Admin | PT. Luminara Global Persada" description="Halaman masuk area admin PT. Luminara Global Persada." />
      <div data-testid="admin-login-card" className="w-full max-w-md bg-navy-900 border border-white/10 p-10 text-center">
        <img src="/assets/logo-mark-gold.png" alt="Logo PT. Luminara Global Persada" className="w-16 h-16 object-contain mx-auto" />
        <h1 className="mt-6 font-heading font-semibold text-2xl text-white">Area Admin</h1>
        <p className="mt-3 text-sm text-slate-400 leading-relaxed">
          Masuk menggunakan akun Google Anda untuk mengakses dashboard PT. Luminara Global Persada.
        </p>
        <button
          data-testid="google-login-button"
          onClick={handleGoogleLogin}
          className="btn-gold w-full mt-8"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z"/>
          </svg>
          Masuk dengan Google
        </button>
        <Link to="/" data-testid="admin-login-back" className="mt-6 inline-block text-xs text-slate-500 hover:text-gold transition-colors duration-300">
          &larr; Kembali ke beranda
        </Link>
      </div>
    </div>
  );
}
